import React, { useContext, useEffect, useCallback } from 'react';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalStates } from '../../GlobalStates';

const Toasty = ({ text = '', type = '', on = false }) => {
  const { alert, setAlert } = useContext(GlobalStates)
  const notify = useCallback(() => toast(alert), [alert]);
  useEffect(() => {
    if (alert) {
      notify()
    }
    setAlert('')
  }, [alert, notify, setAlert])
  return (
    <div>
      <ToastContainer />
    </div>
  );
}
export default Toasty;